import React from 'react'
import Navbar from '../Components/Navbar'
import Search from '../Components/Search'
import Track from '../Components/Track'
import Sold from '../Components/Sold'
import Footer from '../Components/Footer'

const List = () => {
  return (
    <>
      <Navbar />
      <Track />
      <Sold />
      <Footer />
      <Search />
    </>
  )
}

export default List